export const ANNOUNCEMENT_RELEVANCE_POPUP_WAS_SHOWN_COOKIE_KEY = 'announcement_relevance_popup_was_shown';
export const DOWNLOAD_APP_URL = 'https://cian.onelink.me/2426377992?pid=mobile_sidebar';
export const DOWNLOAD_HUAWEI_APP_URL = 'https://appgalleryhuawei.onelink.me/9VFh/3e171a2b';
